import { render, staticRenderFns } from "./AdminManualImport.vue?vue&type=template&id=99f9c13e&scoped=true"
import script from "./AdminManualImport.vue?vue&type=script&lang=js"
export * from "./AdminManualImport.vue?vue&type=script&lang=js"
import style0 from "./AdminManualImport.vue?vue&type=style&index=0&id=99f9c13e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f9c13e",
  null
  
)

export default component.exports